import {IStore} from "modules/types/store";
import { createSelector } from "reselect";

export const getStats = ({stats}: IStore) => stats;

export const getSeasonStatsByID = createSelector(getStats, (stats) => (id: number) => stats[id] ?? {birdies: 0, gir_average: 0, green_in_regulation: 0})
